import asusVGA10701 from '../assets/images/product/productsCard/asusVGA1070-1.jpg'
import asusVGA10702 from '../assets/images/product/productsCard/asusVGA1070-2.jpg'
import asusVGA10703 from '../assets/images/product/productsCard/asusVGA1070-3.jpg'
import asusVGA10705 from '../assets/images/product/productsCard/asusVGA1070-5.jpg'

import cpui76700K1 from '../assets/images/product/productsCard/cpui7-6700K1.jpg'
import cpui76700K2 from '../assets/images/product/productsCard/cpui7-6700K2.jpg'
import cpui76700K3 from '../assets/images/product/productsCard/cpui7-6700K3.jpg'
import cpui76700K4 from '../assets/images/product/productsCard/cpui7-6700K4.jpg'
import cpui76700K5 from '../assets/images/product/productsCard/cpui7-6700K5.jpg'
import cpui76700K6 from '../assets/images/product/productsCard/cpui7-6700K6.jpg'


import mbAsusZ7901 from '../assets/images/product/productsCard/mbAsusZ7901.jpg'
import mbAsusZ7902 from '../assets/images/product/productsCard/mbAsusZ7902.jpg'
import mbAsusZ7903 from '../assets/images/product/productsCard/mbAsusZ7903.jpg'

import corsairDDR41 from '../assets/images/product/productsCard/corsairDDR41.jpg'
import corsairDDR42 from '../assets/images/product/productsCard/corsairDDR42.jpg'
import corsairDDR43 from '../assets/images/product/productsCard/corsairDDR43.jpg'
import corsairDDR44 from '../assets/images/product/productsCard/corsairDDR44.jpg'


import gigaVGA40901 from '../assets/images/product/productsCard/1gigaVGA4090.jpg'
import gigaVGA40902 from '../assets/images/product/productsCard/2gigaVGA4090.jpg'
import gigaVGA40903 from '../assets/images/product/productsCard/3gigaVGA4090.jpg'
import gigaVGA40904 from '../assets/images/product/productsCard/4gigaVGA4090.webp'
import gigaVGA40905 from '../assets/images/product/productsCard/5gigaVGA4090.jpg'

import fanCollerMasterML3601 from '../assets/images/product/productsCard/fanCollerMasterML3601.jpg'
import fanCollerMasterML3602 from '../assets/images/product/productsCard/fanCollerMasterML3602.jpg'
import fanCollerMasterML3603 from '../assets/images/product/productsCard/fanCollerMasterML3603.png'
import fanCollerMasterML3604 from '../assets/images/product/productsCard/fanCollerMasterML3604.png'





export const DATAPRODUCT = [

    {
        '_id': '1',
        'name': 'کارت گرافیک ',
        'images': [
            asusVGA10701,
            asusVGA10702,
            asusVGA10703,
            asusVGA10705,
        ],
        'fullName': ' کارت گرافیک ایسوس مدل  Dual GEFORCE GTX 1070 8GB',
        'content': ' کارت گرافیک «DUAL-GTX1070-O8G» محصولی از شرکت «ایسوس» است که از تراشه‌ی ساخته‌شده توسط شرکت NVIDIA بهره می‌برد. مقدار حافظه‌ی این کارت گرافیک برابر با 8 گیگابایت است که مقدار کاملاً رضایت بخشی برای انجام بازی‌های رایانه‌ای و پردازش‌های گرافیکی سنگین محسوب می‌شود. نوع حاظفه‌ی ارائه‌شده برای DUAL-GTX1070-O8G، GDR5 بوده که از فرکانس مؤثر 8008 مگاهرتز و باس رابط 256 بیت بهره می‌برد. ',
        'price': 8200000,
        'count': 1,
    },
    {
        '_id': '2',
        'name': ' سی پی یو  ',
        'images': [
            cpui76700K1,
            cpui76700K2,
            cpui76700K3,
            cpui76700K4,
            cpui76700K5,
            cpui76700K6,
        ],
        'fullName': ' پردازنده مرکزی اینتل سری Skylake مدل Core i7-6700K',
        'content': ' پردازنده مرکزی Core i7-6700K شرکت اینتل (Intel)، جز ششمین نسل از پردازنده‌های این شرکت است که با استفاده از معماری اسکای‌لیک (Skylake) ساخته شده‌اند. این سری از پردازنده‌های اینتل با فناوری ساخت (لیتوگرافی) 14 نانومتر تولید شده‌اند که به مصرف توان کمتر و بازده بیشتر منجر می‌شود. ',
        'price': 6515000,
        'count': 1,
    },
    {
        '_id': '3',
        'name': 'مادربرد ',
        'images': [
            mbAsusZ7901,
            mbAsusZ7902,
            mbAsusZ7903,
        ],
        'fullName': ' مادربرد ایسوس مدل ROG STRIX Z790-E GAMING WIFI ',
        'content': 'مادربرد ایسوس ROG STRIX Z790-E GAMING WIFI با پیشرفت‌های DDR5 و مجموعه‌ای از گزینه‌های PCIe 5.0 سرعت را بیش‌تر افزایش داده است و به لطف مجموعه ویژگی‌های منحصربه‌فرد Q-Design، راه‌اندازی آن بسیار آسان است.',
        'price': 32400000,
        'count': 1,
    },
    {
        '_id': '4',
        'name': ' رم دسکتاپ ',
        'images': [
            corsairDDR41,
            corsairDDR44,
            corsairDDR42,
            corsairDDR43,

        ],
        'fullName': ' رم دسکتاپ DDR4 چهار کاناله 3600 مگاهرتز CL18 کورسیر ',
        'content': ' رم دسکتاپ DDR4 چهار کاناله 3600 مگاهرتز CL18 کورسیر مدل Vengeance RGB Pro SL ظرفیت 64 گیگابایت',
        'price': 4985000,
        'count': 1,
    },
    {
        '_id': '5',
        'name': ' کارت گرافیک ',
        'images': [
            gigaVGA40901,
            gigaVGA40902,
            gigaVGA40903,
            gigaVGA40904,
            gigaVGA40905,
        ],
        'fullName': ' کارت گرافیک گیگابایت مدل AORUS GeForce RTX 4090 MASTER 24G ',
        'content':'  یکی از قطعاتی که بسیار محبوب است و بوست بسیار بالایی را به سیستم شما می‌دهد کارت گرافیک است. این قطعه می‌تواند برای شما کیفیت تصویر، کشش گرافیکی، قدرت پردازش گرافیکی و هر آنچه در مورد تصویر و گرافیک و مالتی‌مدیا و بازی است را جانی بسیار تازه و پرقدرت ببخشد. کارت گرافیک گیگابایت مدل GeForce RTX 4090 MASTER 24G AORUS یکی از آن‌هایی است که تمامی این موارد را به‌خوبی و با قدرتی بسیار بالا برای شما انجام می‌دهد.',
        'price': 123800000,
        'count': 1,
    },
    {
        '_id': '6',
        'name': ' خنک کننده پردازنده',
        'images': [
            fanCollerMasterML3601,
            fanCollerMasterML3602,
            fanCollerMasterML3603,
            fanCollerMasterML3604,

        ],
        'fullName': ' خنک کننده پردازنده کولر مستر مدل MASTERLIQUID ML360 ILLUSION ',
        'content': ' واتر کولر Masterliquid ML360 illusion به عنوان یکی راهکارهای اصلی برای خنک سازی پردازنده‌های پر قدرت 11900K و 11700K نام برده شده است.واتر کولر‌های ایلوژن که زیر مجموعه خانواده مستر لیکوئید عرضه می‌شوند، از پمپ نسل سومی‌Dual Chamber مدل Mirror استفاده می‌کنند، اما، پشت بلاک، کاملا ارتقا یافته و دیگر خبری از نورپردازی آینه مانند نیست. در عوض بلاک تمام مشکی آن تحت نورپردازی 360 درجه به مانند یک گنبد نورانی روشن می‌شود و علی رغم ظاهر مشکی، بدنه ای کاملا شفاف دارد. در بخش رادیات ... ',
        'price': 8400000,
        'count': 1,
    },
    {
        '_id': '7',
        'name': 'کارت گرافیک ',
        'images': [
            asusVGA10705,

            asusVGA10701,
            asusVGA10702,
            asusVGA10703,
        ],
        'fullName': ' کارت گرافیک ایسوس مدل  Dual GEFORCE GTX 1070 8GB',
        'content': ' کارت گرافیک «DUAL-GTX1070-O8G» محصولی از شرکت «ایسوس» است که از تراشه‌ی ساخته‌شده توسط شرکت NVIDIA بهره می‌برد. مقدار حافظه‌ی این کارت گرافیک برابر با 8 گیگابایت است که مقدار کاملاً رضایت بخشی برای انجام بازی‌های رایانه‌ای و پردازش‌های گرافیکی سنگین محسوب می‌شود. نوع حاظفه‌ی ارائه‌شده برای DUAL-GTX1070-O8G، GDR5 بوده که از فرکانس مؤثر 8008 مگاهرتز و باس رابط 256 بیت بهره می‌برد. ',
        'price': 8200000,
        'count': 1,
    },
    {
        '_id': '8',
        'name': ' سی پی یو  ',
        'images': [
            cpui76700K2,
            cpui76700K5,
            cpui76700K6,
            cpui76700K1,
            cpui76700K3,
            cpui76700K4,
        ],
        'fullName': ' پردازنده مرکزی اینتل سری Skylake مدل Core i7-6700K',
        'content': ' پردازنده مرکزی Core i7-6700K شرکت اینتل (Intel)، جز ششمین نسل از پردازنده‌های این شرکت است که با استفاده از معماری اسکای‌لیک (Skylake) ساخته شده‌اند. این سری از پردازنده‌های اینتل با فناوری ساخت (لیتوگرافی) 14 نانومتر تولید شده‌اند که به مصرف توان کمتر و بازده بیشتر منجر می‌شود. ',
        'price': 6515000,
        'count': 1,
    },



]